<template>
  <div class="workItem" @click.stop="jumpToWorkDetail()" ref="workItem">
    <!-- <div class="img" :style="{ backgroundImage: `url(${getImg(dic.images)})`, height:`${work_img_height}px`}"></div> -->
    <div class="img" :style="{ backgroundImage: `url(${dic.images})`, height:`${work_img_height}px`}"></div>
    <div class="text">
      <span class="title">{{ dic.name }}</span>
      <div :class="`icons ${['user_top', 'move', 'top_applab','activity_works', 'school_product'].includes(dataType) ? 'line': ''}`">
        <span class="zan" @click.stop="likeWorkEvent()">
          <img :src=" `${dic.islike ? images.like_select : images.like_unselect}`" />
          <span class="number">{{ dic.likes }}</span>
        </span>
        <span class="zan browser">
          <img :src="images.eye" />
          <span class="number">{{ dic.browser_count }}</span>
        </span>
      </div>

      <div class="authorWrapper" v-if="['user_top', 'move', 'top_applab','activity_works', 'school_product'].includes(dataType) ">
        <img class="avatar" :src="dic.student.avatar" />
        <span class="name">{{ dic.student.name }}</span>
      </div>
      <span class="time" v-if="dataType ==='my' ">{{ getTimeString(dic.create_time) }}</span>
      <span class="send" @click.stop="sendToCompanyEvent()" v-if="dic.isowner && dataType ==='my'  && !number  && !(dic.remix_from && dic.remix_from.pk !== 1)">发给公司</span>

    </div>
    <!-- 确定参加活动 -->
    <div @click.stop="clickJoinActivity()" class="joinActivity" v-if="dataType=='my' && number">
      <img src="@/assets/addPurple.png" />
    </div>
    <span class="closeWrapper" @click.stop="deleteWork()" v-if="dic.isowner && dataType ==='my' && !number ">
      <span class="close">
        <span class="line1"></span>
        <span class="line2"></span>
      </span>
    </span>
    <span class="remix" v-if="dic.student.user !== '88820190449'">{{dic.remix_from && dic.remix_from.pk !== 1 ? "Remix": "原创"}}</span>
  </div>
</template>

<script>
// @ is an alias to /src
import {
  IMG_WORK__LIKE_SELECT,
  IMG_WORK__LIKE_UNSELECT,
  IMG_EYE
} from '@/assets'
import { Utils } from '@/utils'

import { types as LoginTypes } from "@/store/modules/login";
import { mapState, mapGetters, mapMutations, mapActions } from "vuex";

export default {
  name: "WorkItem",
  components: {},
  props: {
    dic: {
      type: Object
    },
    itemHeight: {
      type: Number,
      default: 120
    },
    dataType: {
      type: String,
      default: ""
    },
    number: String,
  },
  data () {
    return {
      images: {
        like_select: IMG_WORK__LIKE_SELECT,
        like_unselect: IMG_WORK__LIKE_UNSELECT,
        eye: IMG_EYE
      },
      work_img_height: 120,
    };
  },

  methods: {
    ...mapActions({
      dependLoginStatus: LoginTypes.LOAD_LOGIN_STATUS,
    }),

    ...Utils,
    // 点赞作品
    likeWorkEvent () {
      let callback = () => {
        if (this.$parent.likeWorkEvent) {
          // <A><B><C></C></B></A>
          // 加入当前组件是 C，那么this.$parent则访问的是 A中的方法等，要想访问 B中的方法，推荐使用 emit; 
          // 具体用法看 Works.vue 和 Home.vue
          this.$parent.likeWorkEvent(this.dic, this.dataType);
        } else {
          this.$emit('likeWorkEvent', this.dic, this.dataType);
        }
      }
      this.dependLoginStatus().then(callback)
    },
    // 删除作品
    deleteWork () {
      let callback = () => {
        if (this.$parent.deleteWork) {
          this.$parent.deleteWork(this.dic, this.dataType);
        } else {
          this.$emit('deleteWork', this.dic, this.dataType);
        }
      }
      this.dependLoginStatus().then(callback)
    },
    // 将作品放到公司产品中
    sendToCompanyEvent () {
      let callback = () => {
        if (this.$parent.sendToCompanyEvent) {
          this.$parent.sendToCompanyEvent(this.dic, this.dataType);
        } else {
          this.$emit('sendToCompanyEvent', this.dic, this.dataType);
        }
      }
      this.dependLoginStatus().then(callback)
    },
    //作品详情页
    jumpToWorkDetail () {
      if (this.$parent.jumpToWorkDetail) {
        this.$parent.jumpToWorkDetail(this.dic, this.dataType);
      } else {
        this.$emit('jumpToWorkDetail', this.dic, this.dataType);
      }
    },
    clickJoinActivity () {
      if (this.dic.activity_number && this.dic.activity_number.indexOf(this.number) > -1) {
        this.$message.error('该作品已经参加过此活动')
        return
      }
      this.$confirm('你确定要上传这个作品？一个活动只能上传一个作品，如果重复上传，以前的作品将会覆盖。', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$emit('joinActivity', this.dic)
      })
    }
  },
  created () {
  },
  destroyed () {
  },
  mounted () {
    // console.log(this.$refs.workItem.clientWidth);
    if (this.$refs.workItem) {
      this.work_img_height = this.$refs.workItem.clientWidth;    }
  }
};
</script>

<style lang="less" scoped>
.workItem {
  width: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
  .img {
    width: 100%;
    height: 140px;
    background-color: #e1e1e1;
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    border-radius: 3px;
  }
  .text {
    padding-left: 10px;
    padding-right: 10px;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    position: relative;
    .title {
      font-size: 12px;
      color: #333333;
      line-height: 20px;
      overflow: hidden;
      height: 20px;
      margin-top: 5px;
    }

    .icons {
      display: flex;
      flex-direction: row;
      align-items: center;
      // margin-top: 5px;
      // padding-bottom: 5px;
      // margin-bottom: 5px;
      // border-bottom: solid 1px #EBEBEB;
      padding-left: -10px;
      margin-left: -10px;
      padding-left: 10px;
      margin-right: -10px;
      padding-right: 10px;
      &.line {
        margin-top: 5px;
        padding-bottom: 5px;
        margin-bottom: 5px;
        border-bottom: solid 1px #ebebeb;
      }
      .zan {
        // flex: 1;
        // margin-right: 20px;
        font-size: 13px;
        color: #999999;
        display: flex;
        flex-direction: row;
        line-height: 20px;
        overflow: hidden;
        height: 20px;
        // justify-content: center;
        align-items: center;
        flex-grow: 1;
        cursor: pointer;
        &.browser {
          margin-left: 20px;
        }
        img {
          height: 12px;
          margin-right: 3px;
        }
        .number {
          line-height: 20px;
          overflow: hidden;
          height: 20px;
        }
      }
    }
    .authorWrapper {
      display: flex;
      flex-direction: row;
      align-items: center;
      margin-bottom: 5px;
      .avatar {
        width: 24px;
        height: 24px;
        border-radius: 50%;
        margin-right: 5px;
      }
      .name {
        font-size: 11px;
        color: #666666;
        line-height: 20px;
        overflow: hidden;
        height: 20px;
      }
    }

    .time {
      font-size: 14px;
      color: #666666;
      margin-top: 10px;
      margin-bottom: 12px;
    }
    .send {
      padding: 2px 10px;
      border-radius: 15px;
      background-color: #f56501;
      color: #ffffff;
      position: absolute;
      font-size: 12px;
      right: -10px;
      bottom: 10px;
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
    }
  }
  // 作者
  .author {
    height: 42px;
    border-top: 1px solid #ebebeb;
    display: flex;
    align-items: center;
    padding: 0 10px;
    font-size: 10px;
    img {
      width: 20px;
      height: 20px;
      border-radius: 10px;
      margin-right: 6px;
    }
  }
  //加入
  .joinActivity {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 42px;
    border-top: 1px solid #ebebeb;
    img {
      width: 25px;
    }
  }

  .closeWrapper {
    background-color: #f56501;
    color: #ffffff;
    position: absolute;
    font-size: 12px;
    right: 0;
    top: 0;
    width: 30px;
    height: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-bottom-left-radius: 30px;
    .close {
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-left: 0px;
      margin-top: -5px;
      transform: rotate(45deg);
      .line1 {
        position: absolute;
        width: 15px;
        height: 1px;
        background-color: #ffffff;
      }
      .line2 {
        width: 1px;
        height: 15px;
        background-color: #ffffff;
      }
    }
  }
  .remix {
    background-color: #f56501;
    color: #ffffff;
    // border-radius: 15px;
    padding: 1px 5px;
    margin-right: 5px;
    font-size: 10px;
    position: absolute;
    left: 0;
    top: 10px;
    border-bottom-right-radius: 10px;
    border-top-right-radius: 10px;
  }
}
</style>
